import React, { useEffect, useRef, useState } from 'react';
import logo from '../assets/bangu_odonto_new.png';
import heroImg from '../assets/herosection2.jpg';
import heroVideo from '../assets/vd-hero2.mp4';
import { getClinicNumbers } from '../utils/clinicNumbers';

const navLinks = [
  { label: 'Sobre', href: '#sobre' },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Equipe', href: '#equipe' },
  { label: 'Depoimentos', href: '#depoimentos' },
  { label: 'Facebook', href: '#facebook' },
  { label: 'Casos', href: '#casos' },
  { label: 'Localização', href: '#localizacao' },
  { label: 'FAQ', href: '#faq' },
];

const marqueeItems = [
  'Implantes Dentários',
  'Próteses Fixas & Removíveis',
  'Ortodontia Invisível',
  'Lentes de Contato',
  'Clareamento',
  'Tratamento de Canal',
];

const VIDEO_FPS = 24;

const formatTimecode = seconds => {
  const totalFrames = Math.floor(seconds * VIDEO_FPS);
  const frames = totalFrames % VIDEO_FPS;
  const totalSeconds = Math.floor(totalFrames / VIDEO_FPS);
  const secs = totalSeconds % 60;
  const mins = Math.floor(totalSeconds / 60) % 60;
  const hours = Math.floor(totalSeconds / 3600);

  return [hours, mins, secs, frames]
    .map(value => String(value).padStart(2, '0'))
    .join(':');
};

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [timecode, setTimecode] = useState('00:00:00:00');
  const videoRef = useRef(null);
  const { years } = getClinicNumbers();

  const scroll = (e, href) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return undefined;

    const syncTimecode = () => {
      setTimecode(formatTimecode(video.currentTime || 0));
    };

    syncTimecode();
    video.addEventListener('timeupdate', syncTimecode);
    video.addEventListener('seeked', syncTimecode);
    video.addEventListener('loadedmetadata', syncTimecode);

    return () => {
      video.removeEventListener('timeupdate', syncTimecode);
      video.removeEventListener('seeked', syncTimecode);
      video.removeEventListener('loadedmetadata', syncTimecode);
    };
  }, []);

  return (
    <>
      <nav className="nav" id="home">
        <a className="nav-brand" href="#home" onClick={e => scroll(e, '#home')}>
          <img src={logo} alt="Bangu Odonto Clínica" />
        </a>

        <div className="nav-links">
          {navLinks.map(link => (
            <a key={link.href} href={link.href} onClick={e => scroll(e, link.href)}>
              {link.label}
            </a>
          ))}
        </div>

        <a href="#marcar" className="nav-cta" onClick={e => scroll(e, '#marcar')}>
          <span>Marcar consulta</span>
          <span className="arrow">→</span>
        </a>

        <button
          className={`nav-hamburger${menuOpen ? ' open' : ''}`}
          onClick={() => setMenuOpen(open => !open)}
          aria-label="Menu"
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>

      <div
        className={`mobile-menu-backdrop${menuOpen ? ' open' : ''}`}
        onClick={() => setMenuOpen(false)}
        aria-hidden="true"
      />

      <div className={`mobile-menu${menuOpen ? ' open' : ''}`} id="mobile-menu">
        <div className="mobile-menu-panel">
          <div className="mobile-menu-head">
            <span className="mobile-menu-kicker">Navegação</span>
            <span className="mobile-menu-copy">Escolha uma seção para continuar.</span>
          </div>

          <div className="mobile-menu-links">
            {navLinks.map(link => (
              <a key={link.href} href={link.href} onClick={e => scroll(e, link.href)}>
                <span>{link.label}</span>
                <span className="mobile-link-arrow">→</span>
              </a>
            ))}
          </div>

          <div className="mobile-cta-wrap">
            <a className="mobile-cta" href="#marcar" onClick={e => scroll(e, '#marcar')}>
              <span>Marcar consulta</span>
              <span className="arrow">→</span>
            </a>
          </div>
        </div>
      </div>

      <header className="hero" id="top">
        <div className="hero-bg">
          <video
            ref={videoRef}
            className="hero-video"
            autoPlay
            muted
            loop
            playsInline
            poster={heroImg}
          >
            <source src={heroVideo} type="video/mp4" />
          </video>
          <img src={heroImg} alt="Bangu Odonto Clínica" className="hero-fallback" />
        </div>
        <div className="hero-grain"></div>

        <div className="hero-timestamp">
          <div><span className="hero-rec">REC</span></div>
          <div>BANGU ODONTO — FILME INSTITUCIONAL</div>
          <div>TAKE 01 / {timecode}</div>
        </div>

        <div className="hero-content">
          <div className="hero-eyebrow">
            <span className="dot"></span>
            Bangu, Rio de Janeiro / Há {years} anos
          </div>
          <h1 className="hero-title">
            Seu sorriso<br />
            <em>em destaque!</em>
          </h1>
        </div>

        <div className="hero-footer">
          <div className="hero-footer-cell">
            <span>{years}</span>
            <strong>Anos de prática</strong>
          </div>
          <div className="hero-footer-cell">
            <span>Endereço</span>
            <strong>Rua Silva Cardoso, 346 — Bangu</strong>
          </div>
          <div className="hero-footer-cell">
            <span>Especialidades</span>
            <strong>Implantes · Próteses · Ortodontia</strong>
          </div>
          <div className="hero-footer-cell">
            <span>Atendimento</span>
            <strong>Seg-Sex 08h30-18h · Sáb 08h30-12h</strong>
          </div>
        </div>
      </header>

      <section className="marquee">
        <div className="marquee-track">
          <span>
            {marqueeItems.map(item => (
              <React.Fragment key={item}>
                {item} <span className="marquee-sep">●</span>{' '}
              </React.Fragment>
            ))}
          </span>
          <span>
            {marqueeItems.map(item => (
              <React.Fragment key={item}>
                {item} <span className="marquee-sep">●</span>{' '}
              </React.Fragment>
            ))}
          </span>
        </div>
      </section>
    </>
  );
};

export default Header;
